import { Component, Input } from "@angular/core";

@Component({
    selector: "empty-list",
    template: `
        <div class="flex flex-column">
            <div class="flex flex-column p-1 pt-3 pb-3">
                <div class="empty-img">
                    <img src="/assets/images/ORB Logo_sunset.svg" style="width: 100%;">
                </div>

                <h3 *ngIf="primaryText">{{ primaryText }}</h3>
                <h4 class="secondary-message" *ngIf="secondaryText">{{ secondaryText }}</h4>
            </div>
        </div>
    `,
    styleUrls: ["./empty-list.component.scss"]
})
export class EmptyListComponent {
    @Input() primaryText: string;
    @Input() secondaryText: string;
}
